import React, { useState } from "react";

const Tnsc = () => {
  const [showBranches, setShowBranches] = useState(false);
  const [showDigital, setShowDigital] = useState(false);

  return (
    <div className="w-full px-6 py-10">

      {/* PAGE TITLE */}
      <h1 className="text-3xl font-bold text-center text-[#003B73] mb-10">
        TNSACB
      </h1>

      {/* ABOUT */}
      <section className="bg-blue-50 p-10 rounded-xl mb-14">
        <h2 className="text-2xl font-bold text-[#0B1F3A] mb-4">
          About Tamil Nadu State Apex Co-operative Bank
        </h2>
        <p className="text-gray-700 text-lg leading-relaxed mb-4">
          The Tamil Nadu State Apex Co-operative Bank (TNSACB) is registered
          under the Tamil Nadu Co-operative Societies Act, 1983. It functions
          in compliance with the guidelines issued by the Reserve Bank of India
          (RBI) and the National Bank for Agriculture and Rural Development
          (NABARD).
        </p>
        <p className="text-gray-700 text-lg leading-relaxed">
          As the apex institution, TNSACB coordinates, finances, and strengthens
          the Central Co-operative Banks, ensuring the steady flow of credit to
          agricultural and allied sectors.
        </p>
      </section>

      {/* CREDIT ACTIVITIES */}
      <section className="mb-14">
        <h2 className="text-2xl font-bold text-[#0B1F3A] mb-6">
          Credit Activities to Affiliates
        </h2>
        <ul className="list-disc pl-8 space-y-3 text-gray-700 text-lg">
          <li>Short Term Loans for Seasonal Agricultural Operations (STSAO)</li>
          <li>Agricultural and Farm Medium-Term Loans</li>
          <li>Working Capital Loans for Weavers’ Cooperative Societies</li>
        </ul>
      </section>

  {/* SERVICES OFFERED */}
      <section className="bg-gray-100 p-10 rounded-xl mb-16">
        <h2 className="text-2xl font-bold text-[#0B1F3A] mb-6">
          Services Offered
        </h2>
        
        {/* 1) Banking Services */}
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-[#0B1F3A] mb-4">
            1) Banking Services
          </h3>
          <ul className="list-decimal pl-8 space-y-2 text-gray-700 text-lg">
            <li>Collection of Deposits</li>
            <li>Financial Support to Affiliates</li>
            <li>Loans through Own Branches</li>
          </ul>
        </div>

        {/* 2) Loan Products */}
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-[#0B1F3A] mb-4">
            2) Loan Products
          </h3>
          <div className="overflow-x-auto">
            <table className="w-full border border-gray-300 bg-white">
              <thead className="bg-blue-600 text-white">
                <tr>
                  <th className="p-3 text-left border border-gray-300">Sl. No.</th>
                  <th className="p-3 text-left border border-gray-300">Name of the Loan</th>
                  <th className="p-3 text-left border border-gray-300">Eligibility For Loan</th>
                  <th className="p-3 text-left border border-gray-300">Documents Required</th>
                </tr>
              </thead>
              <tbody>
                {[
                  "Jewel Loan",
                  "Loans to Economically Backward Women for Purchase of E-Auto",
                  "Self Help Groups Loan",
                  "Differently Abled Persons Loan",
                  "Housing and House Mortgage Loan",
                ].map((loan, index) => (
                  <tr key={index} className="border-t">
                    <td className="p-3 border border-gray-300">{index + 1}</td>
                    <td className="p-3 border border-gray-300">{loan}</td>
                    <td className="p-3 text-gray-500 border border-gray-300"></td>
                    <td className="p-3 text-gray-500 border border-gray-300"></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* 3) Digital & Modern Banking */}
        <div className="mb-6">
          <button
            onClick={() => setShowDigital(!showDigital)}
            className="text-xl font-semibold text-blue-600 underline mb-4 text-left"
          >
            3) Digital & Modern Banking 
          </button>

          {showDigital && (
            <ul className="list-decimal pl-8 space-y-2 text-gray-700 text-lg">
              <li>IMPS (Immediate Payment Service)</li>
              <li>ATM Facilities</li>
              <li>Micro ATM</li>
              <li>RUPAY Debit Cards</li>
              <li>UPI (Unified Payment Interface)</li>
              <li>CTS (Cheque Truncation System)</li>
              <li>AePS (Aadhaar Enabled Payment System)</li>
              <li>RTGS (Real Time Gross Settlement)</li>
              <li>NEFT (National Electronic Funds Transfer)</li>
              <li>AML (Anti-Money Laundering) System</li>
              <li>Mobile Banking</li>
              <li>Net Banking</li>
              <li>QR Code Payment</li>
            </ul>
          )}
        </div>

        {/* 4) Contact Details */}
        <div>
          <h3 className="text-xl font-semibold text-[#0B1F3A] mb-4">
            4) Contact Details
          </h3>
          <button
            onClick={() => setShowBranches(!showBranches)}
            className="text-blue-600 underline font-medium"
          >
            Branch Details with Address and Phone Number
          </button>

          {showBranches && (
            <div className="mt-4 bg-white p-6 rounded-lg border border-gray-300 text-gray-700">
              Branch details with address and phone number will be displayed here in a popup view.
            </div>
          )}
        </div>
      </section>
      {/* POLICY & REGULATION */}
      <section className="bg-gray-100 p-10 rounded-xl">
        <h2 className="text-2xl font-bold text-[#0B1F3A] mb-4">
          Policy & Regulation
        </h2>
        <p className="text-lg text-gray-700 leading-relaxed">
          Administrative control rests with the Registrar of Cooperative
          Societies. Banking operations are regulated by the Reserve Bank of
          India (RBI) and the National Bank for Agriculture and Rural
          Development (NABARD).
        </p>
      </section>

    </div>
  );
};

export default Tnsc;
